import React from "react";
import { formatString, getEnumKeyByValue } from "../../../utils/helper";
import { LeaseApplicationReferenceTypesEnum } from "@propertelligent/client-api";
import UtilHelper from "../../../utils/UtilHelper";
import { TextCss } from "../../GlobalCss/TextCss";

const ReferencesInfo = ({ References }) => {
  return (
    <>
      {References?.map((item, i) => (
        <div className="rentpay_information-left flexRow p-2 mx-3 gap-3 emp_item">
          <div className="rentpay-avatar">
            {" "}
            <div className="tenant-initials">
              {UtilHelper.getInitials(item?.firstName + " " + item?.lastName)}
            </div>{" "}
          </div>
          <div className="flexColumn gap-2">
            <p className={TextCss.black.heading_700_16}>
              {item?.firstName} {item?.lastName}
              <span className="sub_text green BackgroundlightGreen p-1 mx-2 rounded text-center ">
                {" "}
                {item?.referenceTypeId !== null &&
                item?.referenceTypeId !== undefined
                  ? formatString(
                      getEnumKeyByValue(
                        LeaseApplicationReferenceTypesEnum,
                        item?.referenceTypeId,
                      ),
                    )
                  : null}{" "}
              </span>
            </p>
            <p className="listing-type">
              Employer: {item?.firstName} {item?.lastName}•{item?.email} •{" "}
              {item?.phoneNumber}
            </p>
          </div>
        </div>
      ))}
    </>
  );
};

export default ReferencesInfo;
